module.exports = __webpack_public_path__ + "img/24.1b5641f4.jpg";